import type {DSConfig} from '../dsConfig'
import responsiveConfig from './responsiveConfig'

const config = {
    ...responsiveConfig,
    modulesList: [...responsiveConfig.modulesList, 'themeCssVariablesPublicAPI', 'mobileAlgoPublicApi'],
    extensionsList: [...responsiveConfig.extensionsList, 'mobileAlgo'],
    experimentalConfigOptions: {
        ...responsiveConfig.experimentalConfigOptions,
        dm_enforceStrictValidationEverywhere: {
            configOptions: {
                enforceStrictValidationEverywhere: true
            }
        },
        dm_enforceNoWhitelistDalStrictSchemaValidation: {
            configOptions: {
                enforceNoWhitelistDalStrictSchemaValidation: true
            }
        }
    }
}
export default config satisfies DSConfig
